<style>
.table-responsive {
  position: relative;
  overflow: auto;
  max-height: 500px;
  width:100%;
  padding-top: 0px !important;
}
.table-responsive thead {
    position:sticky;
    top:0px;
}
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}

.new-pemungut{
    border-bottom: 1px solid #000000 !important;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title=" Buku Tunai Pungutan/Terimaan">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <z-lookup
                            label="Jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                         <z-lookup
                            label="Jenis Kaunter"
                            :url="service_laporan + 'lookup/lkp_kaunter_baharu'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_kaunter_id"
                        />
                    </div>
                    
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode table-responsive">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td rowspan="2">Bil</td>
                                <td rowspan="2">Tarikh</td>
                                <td rowspan="2">Bentuk Bayaran</td>
                                <td rowspan="2">No. Resit</td>
                                <td rowspan="2">Amaun</td>
                                <td colspan="5">
                                    Pembayaran Kepada Perbendaharaan
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    No. Pemungut<br />
                                    Tarikh Slip Bank
                                </td>
                                <td>Amaun</td>
                                <td>
                                    No. Resit Perbendaharaan<br />
                                    Tarikh Resit
                                </td>
                                <td>Perbezaan Hari di Bank</td>
                                <td>Status</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.items.length > 0">
                                <tr v-for="(dt, index) in table.items">
                                    <template v-if="index == 0 || table.items[index-1] && table.items[index-1].no_penyata_pemungut != dt.no_penyata_pemungut">
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.no }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.tarikh }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.bentuk_bayaran }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">
                                             <span
                                                v-if="dt.lkp_resit_status_id == 2 && dt.penyata_pemungut_id != null"
                                                style="text-decoration: line-through;"
                                            >
                                                {{ dt.no_resit }}
                                            </span>

                                            <span v-else>
                                                {{ dt.no_resit }}
                                            </span>
                                        </td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.amaun }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.no_penyata_pemungut }}<br>{{dt.tarikh_slip_bank}}</td>
                                        <td style="border-top: 1px solid #000000 !important;">
                                            {{ dt.amaun_pemungut }}
                                        </td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.no_resit_perbendaharaan }}<br>{{dt.tarikh_resit_perbendaharaan}}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.perbezaan_hari_bank }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.status }}</td>
                                    </template>
                                    <template v-else>
                                        <td>{{ dt.no }}</td>
                                        <td>{{ dt.tarikh }}</td>
                                        <td>{{ dt.bentuk_bayaran }}</td>
                                        <td> 
                                            <span v-if="dt.lkp_resit_status_id == 2 && dt.penyata_pemungut_id != null"
                                                style="text-decoration: line-through;" >
                                                {{ dt.no_resit }}
                                            </span>

                                            <span v-else>
                                                {{ dt.no_resit }}
                                            </span>
                                        </td>
                                        <td>{{ dt.amaun }}</td>
                                        <td></td>
                                        <td>
                                            <!-- {{ $zutil.currency(dt.amaun_pemungut) }} -->
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <!-- <td>BELUM SAH</td> -->
                                        <td></td>
                                    </template>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="10" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        
                        </tbody>
                    </table>
                    <w-card class="text-right">
                        <w-flex
                            v-if="table.meta && table.meta.current_page"
                            class="justify-start align-center"
                        >
                        <w-select label-position="left" v-model="cari.per_page" :items="perPageOption" class="xs1" @item-select="search()"></w-select>
                            <pagination
                                class="xs11"
                                :max="table.meta.last_page"
                                :path="table.meta.path"
                                :current="table.meta.current_page"
                                :last_page="table.meta.last_page"
                                :links="table.meta.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            loading: false,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            perPageOption: [
                    {label: '5', value: 5},
                    {label: '10', value: 10},
                    {label: '50', value: 50},
                    {label: '100', value: 100},
                    {label: '9999', value: 9999},
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/buku_tunai"},
                { label: "Laporan", route: "/kutipan/laporan/buku_tunai"},
                {
                    label: "Buku Tunai Terimaan",
                    route: "/kutipan/laporan/buku_tunai",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "", lkp_kaunter_id: "", per_page: 10 },
        };
    },
    methods: {
        search() {
            this.getQueryData();
            // this.$inertia.visit(
            //     window.route("kutipan.laporan.buku_tunai.index") + 
            //         "?tarikh_dari=" + this.cari.tarikh_dari +
            //         "&tarikh_hingga=" + this.cari.tarikh_hingga+
            //         "&jabatan_id=" + this.cari.jabatan_id +
            //         "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id +
            //         "&per_page=" + this.cari.per_page,
            //     { preserveScroll: true }
            // );
        },

        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "", lkp_kaunter_id: "", per_page: 10 };
            this.search();
        },

        cetak() {
            window.open(this.service_laporan+'kutipan/laporan/buku_tunai/cetak?user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga+
            "&jabatan_id=" + this.cari.jabatan_id+
            "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id,'_blank');
            },
        async getQueryData() {
            this.loading = true;
            const resp = await axios.get(
                this.service_laporan + "kutipan/laporan/buku_tunai?user_id=" + this.auth.user.id +
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&jabatan_id=" + this.cari.jabatan_id +
                    "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id +
                    "&page=" + this.cari.page +
                    "&per_page=" + this.cari.per_page,
            );
            this.table = resp.data.data;
            this.table.meta = resp.data.meta;
            this.loading = false;
        },
    },
    watch: {},
    mounted() {
        // console.log(this.datas);
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
        if (this.cari.lkp_kaunter_id == "undefined") {
            this.cari.lkp_kaunter_id = "";
        }
        if(typeof this.cari.per_page === 'undefined'){
            this.cari.per_page = 10;
        } else {
            this.cari.per_page = parseInt(this.cari.per_page);
        }
        if(this.cari.page)
            this.getQueryData()
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
